/**
 * Защита роутов. Legacy редиректил неавторизованных на /login (юзер)
 * и /admin/login (админ) — поведение сохранено.
 */

import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useSession } from '@/session/SessionProvider'

/** Роуты ЛК: без cookie auth_snt — на страницу входа. */
export function RequireUser() {
  const { user } = useSession()
  const location = useLocation()

  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return <Outlet />
}

/** Роуты админки. */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { admin } = useSession()

  if (admin === null) {
    return <Navigate to="/admin/login" replace />
  }
  return <>{children}</>
}
